export const filters = [
  {
    name: "Exchange",
    subfilter: [
      { id: "IEX", title: "IEX" },
      { id: "PXIL", title: "PXIL" },
      { id: "HPX", title: "HPX" },
    ],
  },
  {
    name: "Product",
    subfilter: [
      { id: "Day Ahead", title: "Day Ahead" },
      { id: "Term Ahead", title: "Term Ahead" },
      { id: "Real Time", title: "Real Time" },
      { id: "Intraday", title: "Intraday" },
      { id: "DAM", title: "Renewable Energy" },
    ],
  },
  {
    name: "Month",
    subfilter: [
      { id: 1, title: "Jan-17" },
      { id: 2, title: "Feb-17" },
      { id: 3, title: "Mar-17" },
      { id: 4, title: "Apr-17" },
      { id: 5, title: "May-17" },
      { id: 6, title: "Jun-17" },
      { id: 7, title: "Jul-17" },
      { id: 8, title: "Aug-17" },
      { id: 9, title: "Sep-17" },
      { id: 10, title: "Oct-17" },
      { id: 11, title: "Nov-17" },
      { id: 12, title: "Dec-17" },
      { id: 13, title: "Jan-18" },
      { id: 14, title: "Feb-18" },
      { id: 15, title: "Mar-18" },
      { id: 16, title: "Apr-18" },
      { id: 17, title: "May-18" },
      { id: 18, title: "Jun-18" },
      { id: 19, title: "Jul-18" },
      { id: 20, title: "Aug-18" },
      { id: 21, title: "Sep-18" },
      { id: 22, title: "Oct-18" },
      { id: 23, title: "Nov-18" },
      { id: 24, title: "Dec-18" },
      { id: 25, title: "Jan-19" },
      { id: 26, title: "Feb-19" },
      { id: 27, title: "Mar-19" },
      { id: 28, title: "Apr-19" },
      { id: 29, title: "May-19" },
      { id: 30, title: "Jun-19" },
      { id: 31, title: "Jul-19" },
      { id: 32, title: "Aug-19" },
      { id: 33, title: "Sep-19" },
      { id: 34, title: "Oct-19" },
      { id: 35, title: "Nov-19" },
      { id: 36, title: "Dec-19" },
      { id: 37, title: "Jan-20" },
      { id: 38, title: "Feb-20" },
      { id: 39, title: "Mar-20" },
      { id: 40, title: "Apr-20" },
      { id: 41, title: "May-20" },
      { id: 42, title: "Jun-20" },
      { id: 43, title: "Jul-20" },
      { id: 44, title: "Aug-20" },
      { id: 45, title: "Sep-20" },
      { id: 46, title: "Oct-20" },
      { id: 47, title: "Nov-20" },
      { id: 48, title: "Dec-20" },
      { id: 49, title: "Jan-21" },
      { id: 50, title: "Feb-21" },
      { id: 51, title: "Mar-21" },
      { id: 52, title: "Apr-21" },
      { id: 53, title: "May-21" },
      { id: 54, title: "Jun-21" },
      { id: 55, title: "Jul-21" },
      { id: 56, title: "Aug-21" },
      { id: 57, title: "Sep-21" },
      { id: 58, title: "Oct-21" },
      { id: 59, title: "Nov-21" },
      { id: 60, title: "Dec-21" },
      { id: 61, title: "Jan-22" },
      { id: 62, title: "Feb-22" },
      { id: 63, title: "Mar-22" },
      { id: 64, title: "Apr-22" },
      { id: 65, title: "May-22" },
      { id: 66, title: "Jun-22" },
      { id: 67, title: "Jul-22" },
      { id: 68, title: "Aug-22" },
      { id: 69, title: "Sep-22" },
      { id: 70, title: "Oct-22" },
      { id: 71, title: "Nov-22" },
      { id: 72, title: "Dec-22" },
      { id: 73, title: "Jan-23" },
      { id: 74, title: "Feb-23" },
      { id: 75, title: "Mar-23" },
      { id: 76, title: "Apr-23" },
      { id: 77, title: "May-23" },
      { id: 78, title: "Jun-23" },
      { id: 79, title: "Jul-23" },
      { id: 80, title: "Aug-23" },
      { id: 81, title: "Sep-23" },
      { id: 82, title: "Oct-23" },
      { id: 83, title: "Nov-23" },
      { id: 84, title: "Dec-23" },
      { id: 85, title: "Jan-24" },
      { id: 86, title: "Feb-24" },
      { id: 87, title: "Mar-24" },
      { id: 88, title: "Apr-24" },
      { id: 89, title: "May-24" },
      { id: 90, title: "Jun-24" },
      { id: 91, title: "Jul-24" },
      { id: 92, title: "Aug-24" },
      { id: 93, title: "Sep-24" },
      { id: 94, title: "Oct-24" },
      { id: 95, title: "Nov-24" },
      { id: 96, title: "Dec-24" },
      { id: 97, title: "Jan-25" },
      { id: 98, title: "Feb-25" },
      { id: 99, title: "Mar-25" },
      { id: 100, title: "Apr-25" },
      { id: 101, title: "May-25" },
      { id: 102, title: "Jun-25" },
      { id: 103, title: "Jul-25" },
      { id: 104, title: "Aug-25" },
      { id: 105, title: "Sep-25" },
      { id: 106, title: "Oct-25" },
      { id: 107, title: "Nov-25" },
      { id: 108, title: "Dec-25" },
    ],
  },
];
